import { render } from "./telephoneInspectionList.vue?vue&type=template&id=867796b6&scoped=true"
import script from "./telephoneInspectionList.vue?vue&type=script&lang=js"
export * from "./telephoneInspectionList.vue?vue&type=script&lang=js"

import "./telephoneInspectionList.vue?vue&type=style&index=0&id=867796b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-867796b6"

export default script